import React from 'react';
import { BtnUploadFile } from './BtnUploadFile';
import { BtnUploadFileGeneral } from './BtnUploadFileGeneral';
import { Button } from 'primereact/button';
import { IoReceiptOutline } from 'react-icons/io5';

export const CsFAndAddress = ({ files, setFiles, name, typePerson, show, errors, addNewFileInTheList , deleteFileInTheList}) => {
    return (
        <>
            {/* cargar comprobante de domicilio y CSF */}
            <div className="section-upload-address flex">
                <div className="col-12">

                    <div className="TopText2 pt-8 w-full text-center">
                        <span className='NormalText'
                            style={{
                                fontWeight: "400",

                            }}
                        >
                            {name == "address" ? "Carga comprobantes de domicilio" : name == 'actaRppPoderes' ? "Carga registro publico, poderes y acta constitutiva" : name == 'edosFinancieros' ? "Carga estados financieros" : name == 'edosCtaAval' ? "Carga estados de cuenta del Representante Legal" : "Carga comprobante de domicilio del Representante Legal"}
                        </span>
                        <br />
                        <br />
                        <span className='NormalText py-4'
                        style={{
                            fontSize: '14px',
                            color: '#6E6893',
                            margin: '0px 0px 100px 0px'
                        }}>
                            {name == "address" ? "Si es el mismo comprobante solo carga uno" : ""}
                        </span>
                    </div>
                    <br />

                    <div className="col-12 p-2">
                        <div className="container-btn row flex flex-column items-center justify-center">
                            < BtnUploadFile files={files} setFiles={setFiles} name={name} typePerson={typePerson} show={show} errors={errors} deleteFileInTheList={deleteFileInTheList} addNewFileInTheList={addNewFileInTheList} />
                            {/* <Button
                                type="button"
                                icon={<IoReceiptOutline size={23} />}
                                outlined={true}
                                style={{ maxHeight: '70px',
                                    height: '10%',
                                  margin: 'auto',
                                 }}
                                className={` no-upload-add Receip py-3 w-full`}
                                label={'agrega otro' }                       
                                onClick={() => addNewFileInTheList(name)}
                            /> */}
                             
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}